import { createSelector } from 'reselect';
import { get } from 'lodash';
import { orderReducer } from 'v1/helpers/misc';
import { CustomFieldDefinition, CustomFieldGroupDefinition } from '__types__';

export const getCustomFieldDefinitions = createSelector(
  [(state: any) => state.auth?.settings?.custom_field_definitions],
  (definitions): CustomFieldDefinition[] | undefined => definitions
);

export const getCustomFieldGroupDefinitions = createSelector(
  [(state: any) => state.auth?.settings?.custom_fieldgroup_definitions],
  (definitions): Record<number, CustomFieldGroupDefinition> | undefined =>
    definitions
);

const getProductionFields = (state: any, props: any) => {
  //const productionType = get(state.production_types, ["data", props.typeId]);
  // const productionType = state.resource_types.settings.production_types.find(type => type.id === props.typeId);
  const productionType = Object.values(state.production_types?.data || {}).find(
    (type: any) => type.id === props.typeId
  );
  return productionType
    ? (productionType as any).metastructure?.fields || []
    : [];
};

export const makeGetProductionFields = () =>
  createSelector([getProductionFields], (fields: any) => fields);

const getBookingFields = (state: any, props: any) => {
  const bookingTypes = orderReducer(state.booking_types || {});
  const bookingType = bookingTypes.find(
    (type: any) => type.id === props.typeId
  );
  return bookingType ? bookingType.metastructure?.fields || [] : [];
};

export const makeGetBookingFields = () =>
  createSelector([getBookingFields], (fields: any) => fields);

const getResourceFields = (state: any, props: any) => {
  const resourceType = get(state, ['resource_types', 'data', props.typeId]);
  const fields = get(resourceType, ['metastructure', 'fields'], []);
  return fields.filter((field: any) => field.active);
};
export const makeGetResourceFields = () =>
  createSelector([getResourceFields], (fields: any) => fields);
